import { type ReactNode } from 'react';
import { checkIsAdmin } from '../lib/admin';
import CheckedRoute from './checked-route';

export default function AdminRoute({ children }: { children: ReactNode }) {
  return <CheckedRoute checkFn={checkIsAdmin}>{children}</CheckedRoute>;
}
